<template>
  <div>
    <div class="back-to-jobs-area">
      <b-button variant="outline-primary" @click="backToJobs">
        Back to Jobs
      </b-button>
    </div>
    <b-form class="border p-2" @submit.prevent="onSubmit" :method="'POST'">
      <b-form-group
          id="fieldset-id"
          label-for="id"
          label-size="lg"
          label-class="font-weight-bold pb-0"
          class="required"
          v-if="!run"
        >
        <template slot="label">
          <span v-text="$t('commons.enabled')" />
        </template>

        <b-form-checkbox :disabled=run
          id="checkbox-enabled"
          v-model="form.active"
        />
      </b-form-group>

      <b-form-group
          id="fieldset-id"
          label-for="id"
          label-size="lg"
          label-class="font-weight-bold pb-0"
          class="required"
        >
        <template slot="label">
          <span v-text="$t('commons.job_name')" />
        </template>
        <b-form-input :readonly=run name="name" v-model.trim="form.name" />
      </b-form-group>

      <b-form-group
          id="fieldset-id"
          label-for="id"
          label-size="lg"
          label-class="font-weight-bold pb-0"
          class="required"
        >
        <template slot="label">
          <span v-text="$t('commons.job_command')" />
        </template>
        <b-form-input :readonly=run name="name" v-model.trim="form.command" />
      </b-form-group>

      <b-form-group
          id="fieldset-id"
          label-for="id"
          label-size="lg"
          label-class="font-weight-bold pb-0"
        >
        <template slot="label">
          <span v-text="$t('commons.job_arguments')" />
        </template>
        <b-form-input name="name" v-model.trim="form.arguments" placeholder="Comma separated" />
      </b-form-group>

      <b-form-group
          id="fieldset-id"
          label-for="id"
          label-size="lg"
          label-class="font-weight-bold pb-0"
        >
        <template slot="label">
          <span v-text="$t('commons.task_definition')" />
        </template>
        <b-form-select v-model.trim="form.task_definition">
          <option value="">-- None -- </option>
          <option v-for="(item, key) in task_definitions" :value="item" :key="key">{{ item }}</option>
        </b-form-select>
      </b-form-group>

      <b-form-group
          id="fieldset-id"
          label-for="id"
          label-size="lg"
          label-class="font-weight-bold pb-0"
          class="required"
        >
        <template slot="label" v-if="!run">
          <span v-text="$t('commons.cron_schedule')" />
          <p style="font-size: 14px">
            <code>Examples: "1 * * * *",  "*/5 * 1 * *", "12 1-5 * * *"</code>
          </p>

          <b-row>
            <b-col>
              <b-form-input v-model="form.cron_schedule" placeholder=""></b-form-input>
            </b-col>
          </b-row>
        </template>
      </b-form-group>

      <b-button type="submit" ref="submitbutton" variant="primary">Submit</b-button>
    </b-form>
    <div class="mt-3 alert alert-info" v-if="message" v-text="message"></div>
  </div>
</template>

<script>
import { DEFAULT_EXTENSIONS } from '@babel/core';

import JobApi from '../../apis/JobsApi';

export default {
  name: 'Job-Form',
  data() {
    return {
      message: null,
      form: {
        active: '',
        name: '',
        command: '',
        arguments: '',
        task_definition: '',
        cron_schedule: ''
      },
      run: false
    }
  },
  methods: {
    backToJobs() {
      window.location.href = '/jobs';
    },
    async getJob(id) {
      const result = await JobApi.getJob(id);
      if (result && result.id) {
        this.form = result;
      }
    },
    async onSubmit() {
      const self = this;

      if (this.job && this.job.length > 0 && this.run) {
        JobApi.runNow(this.job, this.form)
        .then((r) => {
          self.message = "Job Initiated!";
        })
        .catch(error => {
          if (error.response.status == 422) {
            self.message = error.response.data.message;
          } else {
            self.message = "A server error was encountered.";
          }
        });
      } else if (this.job && this.job.length > 0 && (!this.run)) {
        JobApi.saveJob(this.job, this.form)
        .then((r) => {
          self.message = "Job Saved Successfully!";
        })
        .catch(error => {
          if (error.response.status == 422) {
            self.message = error.response.data.message;
          } else {
            self.message = "A server error was encountered.";
          }
        });
      } else if (!this.run) {
        JobApi.addJob(this.form)
        .then((r) => {
          self.message = "Job Saved Successfully!";
        })
        .catch(error => {
          self.message = "A server error was encountered.";
        });
      }
    }
  },
  props: {
    job: {
      type: String,
      required: false
    },
    run_now: {
      type: String,
      required: false
    },
    task_definitions: {
      type: Array,
      required: true
    }
  },
  mounted() {
    if (this.job && this.job.length > 0) {
      this.getJob(this.job);
    }
    if(this.run_now) {
      this.run = (this.run_now == 'true');
      this.$refs.submitbutton.innerText = 'Run now';
    }
  }
}
</script>

<style scoped>
.bottom-button {
  margin-top: 20px;
}
.back-to-jobs-area {
  margin-bottom: 20px;
}
</style>